const useCurrentOrigin = process.env.NODE_ENV === 'production';

const hubBaseUrl = useCurrentOrigin
    ? window.location.origin
    : (process.env.VUE_APP_WP_BASE_URL || window.location.origin);

const apiBaseUrl = useCurrentOrigin
    ? window.location.origin
    : (process.env.VUE_APP_API_BASE_URL || hubBaseUrl);

const hubHost = new URL(hubBaseUrl).host;

export { apiBaseUrl, hubBaseUrl, hubHost };
